<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="jobId"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [required]="required"
    [disabled]="disabled"
    [errorStateMatcher]="errorStateMatcher"
  >
    @for (jobType of jobTypeService.allJobTypes$ | async; track $index) {
      <mat-option [value]="jobType.id">
        {{ jobType.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
